import { render, staticRenderFns } from "./helpFeatures.vue?vue&type=template&id=151d635a&"
import script from "./helpFeatures.vue?vue&type=script&lang=js&"
export * from "./helpFeatures.vue?vue&type=script&lang=js&"
import style0 from "./helpFeatures.vue?vue&type=style&index=0&id=151d635a&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/js/module/layout/_source/helpFeatures.vue
// module id = 515
// module chunks = 30